export const country = {
  state: {
    countries: [
      /*
      */
    ]
  },
  mutations: {
    updateCountries: function(state, newList) {
      state.countries = newList;
    },
    removeCountries: function(state) {
      state.countries = [];
    }    
  },
  actions: {
    clearCountries: function({ commit }) {
      commit("removeCountries");
    }
  },
  getters: {
    getAllCountries(state) {
      return state.countries;
    },
    getCountryByCode(state) {
      return function(country_code) {
        return state.countries.find(function(a) {
          return (a.code === country_code)
        })
      }
    }
  }
}